"use strict";
export default {
  await: "\u7B49\u5F85\u4E2D",
  running: "\u4E0A\u4F20\u4E2D",
  success: "\u5DF2\u6210\u529F",
  error: "\u5DF2\u5931\u8D25"
};
